// Definir tipo para FormNovoOrcamento
interface FormNovoOrcamento {
  [key: string]: any;
}

export const useStore = defineStore('store', {
    state: () => ({
        key: 0,
        loading: false,
        sidebarVisible: false,
        sidebarUnfoldable: true,
        theme: 'light',
        formNovoOrcamento: {} as FormNovoOrcamento,
        modaisAbertos: [] as { modal: any, aoFechar: any | null }[],
        cartorio: {
            cor: '',
        },
        usuario: {
            foto: '',
        },
        toasts: [] as Array<{ title?: string, content: string; color: string }>,
        competencia: {
            mes: new Date().getMonth() + 1,
            ano: new Date().getFullYear(),
        },
        modalInatividade: {
            exibir: false,
            tempoRestante: 0,
            tempoLimite: 30 * 60 * 1000, // 30 minutos
        },
    }),
});